const platformCampaignFilter = (platformCampaignData, searchTerm) =>
  platformCampaignData.filter(platformCampaign =>
    platformCampaign.props.name.toLowerCase().includes(searchTerm),
  );

export default platformCampaignFilter;
